import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { PageOuter } from 'components/PageContainers';
import Arrow from 'images/arrow-right-light.inline.svg';
import { fetchData, getDataUrls } from 'data/site-banner';
import { useDynamicContent, DynamicContentView } from 'components/dynamic-content';
import { ISiteBanner } from 'types';

const useStyles = createUseStyles((theme) => ({
  root: {
    background: theme.colors.purple,
    padding: '15px'
  },
  p: {
    color: theme.colors.white,
    textAlign: 'center',
    lineHeight: '2.6rem'
  },
  content: {
    color: theme.colors.white,
    fontSize: '1.4rem',
    margin: '0',
    lineHeight: '2.6rem',
    '&:hover': {
      opacity: 1
    }
  },
  contentArrow: {
    '&:after': {
      content: "'\\276F'",
      paddingLeft: '.5em',
      top: '0'
    }
  },
  arrow: {
    marginLeft: '5px',
    width: '12px'
  }
}));

interface IProps {
  siteBanner: ISiteBanner | null;
}

const SiteBanner: React.FunctionComponent<IProps> = ({ siteBanner }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  if (!siteBanner) {
    const { loading, data } = useDynamicContent<ISiteBanner | null>(fetchData, siteBanner);
    return (
      <DynamicContentView loading={loading} dataUrls={getDataUrls()}>
        {data && (
          <div className={styles.root}>
            <PageOuter>
              {data.url ? (
                <a href={data.url} className={styles.p}>
                  <div className={styles.content + ' ' + styles.contentArrow}>{data.content}</div>
                </a>
              ) : (
                <p className={styles.p}>
                  <div className={styles.content}>{data.content}</div>
                </p>
              )}
            </PageOuter>
          </div>
        )}
      </DynamicContentView>
    );
  } else {
    return (
      <div className={styles.root}>
        <PageOuter>
          {siteBanner.url ? (
            <a href={siteBanner.url} className={styles.p}>
              <div className={siteBanner.content + ' ' + styles.contentArrow}>{siteBanner.content}</div>
            </a>
          ) : (
            <p className={styles.p}>
              <div className={siteBanner.content}>{siteBanner.content}</div>
            </p>
          )}
        </PageOuter>
      </div>
    );
  }
};

export default SiteBanner;
